import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  OnChanges,
  ElementRef,
  Inject,
  OnDestroy,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import NeoVis, { Neo4jConfig, NeovisConfig, Node } from 'neovis.js';
import { GDialogComponent } from '../graph/gdialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Default_Config } from '../graph/default-cipher-config';
import { Edge } from 'vis-network';
import { NeovisService } from 'src/app/services/neovis.service';
import { ModalImportComponent } from './modal-import/modal-import.component';
import { NeoVisConfigSingleton } from '../src/classes/neovis-class';
import { ImportNodesFunction, ImportEdgesFunction } from './utils/import-excel';
import { ExportGraph } from './utils/export-excel';
import { InitQuerys, Neo4jQuerys } from './utils/neo4j-querys';
import {
  addAccountNode,
  addCasoNode,
  addCustomerNode,
  addDefaultNode,
} from '../src/utlis/add-node-lists';
import { Router } from '@angular/router';
import { ForceGraphComponent } from '../3d-force-graph/3d-force-graph.component';
import { SelectApiSlComponent } from './select-api-sl/select-api-sl.component';
import { KeySlService } from 'src/app/services/key-sl.service';
import { Subscription } from 'rxjs';
import { valueRelationByApi } from './utils/realtions-sl-api';
import { log } from 'console';
import { DetailsNodeSlComponent } from '../graph/details-node-sl/details-node-sl.component';

interface NodeList {
  id: number;
  titulo: string;
  description: string;
  type: string;
  color: string;
  icon: string;
  node_object: Node;
  checked: boolean;
}

export interface NodeAndLinks {
  nodes: Node[];
  links: Edge[];
}

@Component({
  selector: 'app-neovis',
  templateUrl: 'neovis-graph.component.html',
  styleUrls: ['../graph/graph.component.css'],
})
export class NeoVisComponent implements OnInit, OnChanges, OnDestroy {
  @Output() out = new EventEmitter<string>();
  @Input() reference: string = ''; // The reference to display
  @Input() element: any = null; // The HTML element to attach the Neo4j visualization to
  @Input() showConsulta: boolean = false; // Indicates whether to show the search bar

  // Output properties
  @Output() nodesAndLinks = new EventEmitter<NodeAndLinks>(); // Event emitter for the nodes and links in the graph

  // View child properties
  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger; // Reference to the right-click menu trigger
  @ViewChild('vis') visElement: ElementRef;

  // Menu right click
  menuTopLeftPosition = { x: '0', y: '0' }; // Position of the right-click menu

  // Selected node properties
  node: Node; // The currently selected node
  node_type: string; // The type of the currently selected node

  /**
   * Indicates whether this is the first time the component is being loaded.
   * Used to determine whether to initialize the graph or update it.
   */
  first = true;

  // ─── Posicionamiento sin physics ──────────────────────────────────────────
  private gridSlot = 0;
  private readonly GRID_COLS = 6;
  private readonly MIN_DISTANCE = 120;
  private nodePositions: { [nodeId: string]: { x: number; y: number } } = {};
  // ──────────────────────────────────────────────────────────────────────────

  // Other properties
  undo_object = null; // Object for undoing changes to the graph
  nodes: NodeList[]; // List of nodes to display in the sidebar
  account_count: number = 0; // Number of accounts in the sidebar
  client_count: number = 0; // Number of customers in the sidebar
  cases_count: number = 0; // Number of cases in the sidebar
  truecaller_count: number = 0; // Number of cases in the sidebar

  nodeListDefault: any = {}; // Object containing the default nodes
  count_type: string = 'Customer'; // Type of node to count in the sidebar
  config: NeovisConfig; // Configuration object for the Neo4j visualization
  consulta: string = ''; // Search term for filtering nodes in the sidebar
  cuentas = []; // List of accounts in the sidebar
  clientes = []; // List of customers in the sidebar
  casos = []; // List of cases in the sidebar
  truecaller = []; // List of truecaller in the sidebar
  private neovis: any; // Reference to the Neo4j visualization
  neo4jQuerys: Neo4jQuerys = null; // Object containing the Neo4j queries
  private graphUpdateSubscription: Subscription;
  actualQuery;
  constructor(
    private neovisService: NeovisService,
    public dialog: MatDialog,
    private router: Router,
    private keySlService: KeySlService
  ) {}

  /**
   * Initializes neo4jQuerys with InitQuerys function
   * @param reference - The name of the reference to initialize neo4jQuerys with
   */
  querys_init(reference: string) {
    this.neo4jQuerys = InitQuerys(reference);
  }

  /**
   * Initializes querys, gets reference name from element and assigns it to reference variable,
   * initializes querys again, starts and renders Neovis
   */
  ngOnInit(): void {
    // Suscribirse a las notificaciones de actualización
    this.graphUpdateSubscription = this.keySlService.graphUpdate$.subscribe(
      (data) => {
        this.updateNeovis(
          data.customerId,
          data.apiUsed,
          data.selectedNodeLabel
        );
      }
    );
  }
  ngOnDestroy() {
    // Desuscribirse al destruir el componente
    if (this.graphUpdateSubscription) {
      this.graphUpdateSubscription.unsubscribe();
    }
  }
  ngOnChanges() {}

  ngAfterViewInit() {}

  initNeovis() {
    const element = document.getElementById('vis-chart');
    console.log('THIS REFERENCE', this.element, this.visElement, element);
    if (this.element) {
      this.reference = this.element.reference;
      if (this.element.investigationType == 'cedula')
        this.reference = this.element.reference.split('- ')[1];
      if (this.element.investigationType == 'caso')
        this.reference = this.element.reference.split('- ')[1];
      console.log('STARTING NEOVIS', this.reference);
      this.querys_init(this.reference);
      (() => {
        const component = this;
        function waitForElement() {
          // console.log("Waiting for element vis-chart to be rendered")
          const element = document.getElementById('vis-chart');
          if (element === null) {
            // console.log('Element not found');
            setTimeout(waitForElement, 2000);
          } else {
            // console.log('Element found:', element);
            setTimeout(() => {
              console.log(
                'Rendering Neovis',
                document.getElementById('vis-chart')
              );
              component.startNeovis();
              component.neovis.render();

              const map = document.querySelector('.demo-chart');
              map.addEventListener('mousemove', (args: MouseEvent) => {
                component.menuTopLeftPosition.x = args.clientX + 'px';
                component.menuTopLeftPosition.y = args.clientY + 'px';
              });
            }, 100);
          }
        }
        waitForElement(); // Call the function
      })();
    }
  }
  adaptAdditionalQuery(
    actualQuery: string,
    customerId: string,
    apiUsed: string,
    selectedNodeLabel: string
  ): string {
    // Extraer las columnas de actualQuery
    const returnRegex = /RETURN\s+(.+)/i;
    const match = actualQuery.match(returnRegex);

    if (!match) {
      throw new Error('No se encontró la cláusula RETURN en actualQuery.');
    }

    const actualColumns = match[1].split(',').map((col) => col.trim());

    // Obtener la relación dinámica
    const relation = valueRelationByApi[apiUsed];
    if (!relation) {
      throw new Error(`No se encontró una relación para la API: ${apiUsed}`);
    }

    // Mapear las columnas de actualQuery a las de additionalQuery
    const columnMapping = {
      c1: 'c AS c1', // Si actualQuery tiene c1, additionalQuery debe devolver c AS c1
      a: 'NULL AS a', // Si actualQuery tiene a, additionalQuery debe devolver NULL AS a
      r: 'r', // Si actualQuery tiene r, additionalQuery debe devolver r
      r2: 'NULL AS r2', // Si actualQuery tiene r2, additionalQuery debe devolver NULL AS r2
      a2: 't AS a2', // Si actualQuery tiene a2, additionalQuery debe devolver t AS a2
    };

    // Construir additionalQuery con las mismas columnas que actualQuery
    const additionalQuery = `
      MATCH (c:\`${selectedNodeLabel}\` {id: '${customerId}'})-[r:${relation}]->(t)
      RETURN ${actualColumns
        .map((col) => {
          const columnName = col.split(' AS ')[0]; // Extraer el nombre de la columna (por ejemplo, c1 AS c -> c1)
          return columnMapping[columnName] || `NULL AS ${col}`;
        })
        .join(', ')}
    `;

    return additionalQuery;
  }
  updateNeovis(customerId: string, apiUsed: string, selectedNodeLabel: string) {
    // Generar additionalQuery adaptada a las columnas de actualQuery
    const additionalQuery = this.adaptAdditionalQuery(
      this.actualQuery,
      customerId,
      apiUsed,
      selectedNodeLabel
    );

    // Combinar las consultas
    const combinedQuery = `
    ${this.actualQuery}
    UNION
    ${additionalQuery}
  `;

    try {
      // Asignar la consulta combinada a Neovis
      // this.neovis.cypher = combinedQuery;
      console.log('Consulta combinada:', combinedQuery);

      // Renderizar el gráfico con la nueva consulta
      // this.neovis.renderWithCypher(combinedQuery);
      this.neovis.updateWithCypher(additionalQuery);
      // Registrar evento de grafo completado
      // this.neovis.registerOnEvent('completed', () => {
      //   console.log('Grafo renderizado:', this.neovis.network.body.data);
      //   console.log(
      //     'Datos del grafo:',
      //     this.neovis.network.body.data.nodes,
      //     this.neovis.network.body.data.edges
      //   );
      //   this.createNodesListSidebar(this.neovis.network.body.data.nodes);
      // });

      // Registrar evento de error
      this.neovis.registerOnEvent('error', (error) => {
        console.error('Error al ejecutar la query:', error);
      });
    } catch (error) {
      console.log(error);
    }

    // Logs de depuración
    console.log('API usada:', apiUsed);
    console.log('Relación para API:', valueRelationByApi[apiUsed]);
    console.log('Consulta combinada:', combinedQuery);
    console.log('Grafo actualizado con nuevos datos.');
  }

  /**
   * Clears cuentas, clientes, and casos arrays, loops through nodes and adds them to corresponding arrays based on their label,
   * sets account_count, client_count, and cases_count to the length of their corresponding arrays
   * @param nodes - The list of nodes to create the sidebar with
   */
  createNodesListSidebar(nodes: Node[]) {
    this.cuentas = [];
    this.clientes = [];
    this.casos = [];
    this.truecaller = [];
    nodes.forEach((node) => {
      if (node.raw.labels[0] == 'Account') {
        this.cuentas.push(addAccountNode(node, this.consulta.toLowerCase()));
      } else if (node.raw.labels[0] == 'Customer') {
        this.clientes.push(addCustomerNode(node, this.consulta.toLowerCase()));
      } else if (node.raw.labels[0] == 'casos') {
        this.casos.push(addCasoNode(node, this.consulta.toLowerCase()));
      } else if (node.raw.labels[0] == 'truecaller') {
        this.truecaller.push(addCasoNode(node, this.consulta.toLowerCase()));
      } else {
        if (this.nodeListDefault[node.raw.labels[0]]) {
          this.nodeListDefault[node.raw.labels[0]].push(
            addDefaultNode(node, this.consulta.toLowerCase())
          );
        } else {
          this.nodeListDefault[node.raw.labels[0]] = [
            addDefaultNode(node, this.consulta.toLowerCase()),
          ];
        }
      }
    });

    this.account_count = this.cuentas.length;
    this.client_count = this.clientes.length;
    this.cases_count = this.casos.length;
    this.truecaller_count = this.truecaller.length;
  }

  /**
   * Sets count_type to the passed in type, recreates nodes list sidebar with current nodes
   * @param type - The type of count to change to
   */
  changeCountType(type: string) {
    this.count_type = type;
    this.createNodesListSidebar(this.neovis.nodes.get());
  }

  /**
   * Opens GDialogComponent with node data and panelClass
   */
  openDetail() {
    this.dialog.open(GDialogComponent, {
      data: { node: this.node, nodeId: this.node.id },
      panelClass: 'custom-dialog-container',
    });
  }
  /**
   * Opens GDialogComponent with node data and panelClass
   */
  openDetailSLNode() {
    this.dialog.open(DetailsNodeSlComponent, {
      data: { node: this.node, nodeId: this.node.id },
      panelClass: 'custom-dialog-container',
    });
  }

  /**
   * If node is already in nodes, remove it. Otherwise, add it.
   * @param node - The node to add or remove from the nodes list
   */
  changeNodeCheck(node: NodeList) {
    this.neovis.nodes.get(node.id)
      ? this.neovis.nodes.remove(node.id)
      : this.neovis.nodes.add(node.node_object);
  }

  /**
   * Executes a search query based on the selected search type
   * @param searchType - the type of search to execute
   */
  search(searchType: string) {
    // Store the current state of the graph before executing the search
    this.undo_object = {
      nodes: this.neovis.nodes.get(),
      edges: this.neovis.edges.get(),
    };

    // Create a regular expression to match the search term
    const regex = new RegExp(this.reference, 'g');

    // Determine the query to execute based on the selected search type and the current node
    let query: string;
    let value: any = this.node.label;

    if (this.neo4jQuerys[searchType]) {
      value = this.node.raw.properties._id;
      console.log('this.neo4jQuerys[searchType]', this.neo4jQuerys[searchType]);
      console.log('regex', regex);
      query = this.neo4jQuerys[searchType].replace(regex, value.toString());
    }

    switch (searchType) {
      case 'CustomerByAccount':
        query = this.neo4jQuerys.AT_37_match_customer_with_account.replace(
          regex,
          value.toString()
        );
        break;
      case 'TransfersByAccount':
        query = this.neo4jQuerys.AT_37_match_transfers_with_account.replace(
          regex,
          value.toString()
        );
        break;
      case 'AccountsByCustomer':
        value = this.node.value;
        query = this.neo4jQuerys.AT_37_match_accounts_with_CI.replace(
          regex,
          value.toString()
        );
        break;
      case 'AccountsAndTransfersByCustomer':
        value = this.node.value;
        query =
          this.neo4jQuerys.AT_37_match_transfers_and_accounts_by_CI.replace(
            regex,
            value.toString()
          );
        break;
      case 'match_2best_transfers_by_account_by_CI':
        value = this.node.value;
        query =
          this.neo4jQuerys.AT_37_match_2best_transfers_by_account_by_CI.replace(
            regex,
            value.toString()
          );
        break;
      case 'match_cases_of_customer':
        value = this.node.value;
        query = this.neo4jQuerys.AT_37_match_cases_of_customer.replace(
          regex,
          value.toString()
        );
        break;
      case 'match_customer_of_case':
        value = this.node.raw.properties.numero_de_identificacion.slice(1);
        query = this.neo4jQuerys.AT_37_search_match_customer.replace(
          regex,
          value.toString()
        );
        break;

      default:
        if (!query) throw new Error(`Invalid search type: ${searchType}`);
    }

    // Log the query and update the graph with the results of the search
    console.log(query);
    this.actualQuery = query;
    this.neovis.updateWithCypher(query);
  }
  async socialLinkSearch() {
    const dialogRef = this.dialog.open(SelectApiSlComponent, {
      data: { node: this.node, nodeId: this.node.id },
      panelClass: 'custom-dialog-container',
    });
    dialogRef.afterClosed().subscribe((res) => {
      console.log('res desde el neovis-grph.compoenet');
    });
  }
  /**
   * Handles click event on a node in the graph
   * @param node - the clicked node
   */
  onClickNode(node: any) {
    // Find the node in the graph by its ID
    const clickedNode = this.neovis.nodes
      .get()
      .find((n) => n.id == node.nodes[0]);

    // If the node is found, update the component state and open the context menu
    if (clickedNode) {
      this.node = clickedNode;
      const item = {};
      this.matMenuTrigger.menuData = { item };
      this.matMenuTrigger.openMenu();
      console.log(clickedNode);

      // Determine the type of the clicked node based on its value property
      this.node_type = clickedNode.raw.labels[0];
    }
  }
  /**
   * @param e - The input change event
   * Sets consulta to the input value and recreates nodes list sidebar with current nodes
   */
  async onInputChange(e) {
    // Set consulta to the input value
    this.consulta = e;

    // Recreate nodes list sidebar with current nodes
    this.createNodesListSidebar(this.neovis.nodes.get());
  }

  /**
   * @param eventData - The data associated with the chart event
   * @param eventType - The type of chart event
   * Opens GDialogComponent with node data and panelClass
   */
  onChartEvent(eventData: any, eventType: string) {
    this.dialog.open(GDialogComponent, {
      data: { node: eventData.data },
      panelClass: 'custom-dialog-container',
    });
  }

  //llama si hay algun error
  onError(error) {
    console.error('Error al conectar con Neo4j:', error);
    // Aquí puedes mostrar un mensaje de error al usuario
  }
  // ─── Layout sin physics ────────────────────────────────────────────────────

  private calculateGridPosition(): { x: number; y: number } {
    const canvasWidth = 2000;
    const startX = canvasWidth * 0.4;
    const startY = 200;
    const col = this.gridSlot % this.GRID_COLS;
    const row = Math.floor(this.gridSlot / this.GRID_COLS);
    this.gridSlot++;
    return {
      x: startX + col * this.MIN_DISTANCE,
      y: startY + row * this.MIN_DISTANCE,
    };
  }

  private getRelatedNodeIds(nodeId: string, edges: any[]): string[] {
    const related = new Set<string>();
    edges.forEach((edge: any) => {
      if (edge.from === nodeId) related.add(edge.to);
      if (edge.to === nodeId) related.add(edge.from);
    });
    return Array.from(related);
  }

  private calculateNodePosition(
    nodeId: string,
    nodes: any[],
    edges: any[],
    existingPositions: { [nodeId: string]: { x: number; y: number } },
  ): { x: number; y: number } {
    const relatedIds = this.getRelatedNodeIds(nodeId, edges);
    const relatedWithPosition = relatedIds.filter(
      (id) => existingPositions && existingPositions[id],
    );

    if (relatedWithPosition.length > 0) {
      let sumX = 0, sumY = 0;
      relatedWithPosition.forEach((id) => {
        const pos = existingPositions[id];
        sumX += pos.x;
        sumY += pos.y;
      });
      const avgX = sumX / relatedWithPosition.length;
      const avgY = sumY / relatedWithPosition.length;
      const angle = (Math.random() * Math.PI) / 2 - Math.PI / 4;
      const offset = this.MIN_DISTANCE * 0.75;
      return {
        x: avgX + Math.cos(angle) * offset,
        y: avgY + Math.sin(angle) * offset,
      };
    }

    return this.calculateGridPosition();
  }

  private applyUniformGridLayout(nodes: any[], edges: any[]): void {
    void edges;
    if (!nodes?.length) return;

    const centerNode = nodes[0];
    const centerPos = { x: 0, y: 0 };
    centerNode.x = centerPos.x;
    centerNode.y = centerPos.y;
    this.nodePositions[centerNode.id] = centerPos;

    const orbitNodes = nodes.slice(1);
    if (!orbitNodes.length) return;

    const baseRingRadius = this.MIN_DISTANCE * 1.9;
    let ring = 1;
    let consumed = 0;

    while (consumed < orbitNodes.length) {
      const ringNodeCapacity = Math.max(this.GRID_COLS * ring, 6);
      const ringNodes = orbitNodes.slice(consumed, consumed + ringNodeCapacity);
      const radius = baseRingRadius * ring;

      ringNodes.forEach((node: any, index: number) => {
        const angle = (2 * Math.PI * index) / ringNodes.length - Math.PI / 2;
        const pos = {
          x: Math.cos(angle) * radius,
          y: Math.sin(angle) * radius,
        };
        node.x = pos.x;
        node.y = pos.y;
        this.nodePositions[node.id] = pos;
      });

      consumed += ringNodes.length;
      ring += 1;
    }
  }

  private applyPositionsToNodes(
    nodes: any[],
    edges: any[],
    forceRedistribute: boolean = false,
  ): void {
    if (forceRedistribute) {
      this.gridSlot = 0;
      this.nodePositions = {};
      this.applyUniformGridLayout(nodes, edges);
      return;
    }

    nodes.forEach((node: any) => {
      const pos = this.calculateNodePosition(
        node.id,
        nodes,
        edges,
        this.nodePositions,
      );
      node.x = pos.x;
      node.y = pos.y;
      this.nodePositions[node.id] = pos;
    });
  }

  private applyNoPhysicsLayout(isInitialLoad: boolean): void {
    this.neovis.network.setOptions({
      physics: { enabled: false, stabilization: { enabled: false } },
    });

    const allNodes: any[] = this.neovis.nodes.get();
    const allEdges: any[] = this.neovis.edges.get();

    if (isInitialLoad) {
      this.applyPositionsToNodes(allNodes, allEdges, true);
    } else {
      const newNodes = allNodes.filter(
        (n: any) => this.nodePositions[n.id] === undefined,
      );
      if (newNodes.length) {
        this.applyPositionsToNodes(newNodes, allEdges, false);
      }
    }

    const updates = allNodes
      .filter((n: any) => this.nodePositions[n.id] !== undefined)
      .map((n: any) => ({
        id: n.id,
        x: this.nodePositions[n.id].x,
        y: this.nodePositions[n.id].y,
      }));

    if (updates.length) {
      this.neovis.nodes.update(updates);
    }

    setTimeout(() => {
      this.neovis.network?.fit({
        animation: { duration: 800, easingFunction: 'easeInOutQuad' },
      });
    }, 300);
  }

  // ──────────────────────────────────────────────────────────────────────────

  /**
   * Called when the query execution is completed.
   * Updates the graph if it has already been initialized, otherwise initializes it.
   * Also creates a sidebar with a list of nodes.
   * @param recordNumber The number of records returned by the query.
   */
  onCompleted(recordNumber: number) {
    // Remove click event listener to prevent multiple listeners from being added
    this.neovis.network.off('click');
    // Add click event listener to nodes
    this.neovis.network.on('click', this.onClickNode.bind(this));

    const isInitialLoad = this.first;

    // If the graph has already been initialized, update it
    if (!this.first) {
      // Save the current state of the graph to the element's 'neovis_search' property and update the element in the database
      this.element.neovis_search = {
        nodes: this.neovis.nodes.get(),
        edges: this.neovis.edges.get(),
      };
      this.neovisService.update(this.element).subscribe((response) => {});
    } else if (this.element.neovis_search) {
      // If the graph has not been initialized, initialize it and save the current state of the graph to the 'undo_object' property
      for (let node of this.element.neovis_search.nodes) {
        try {
          this.neovis.nodes.add(node);
        } catch {}
      }
      for (let edge of this.element.neovis_search.edges) {
        try {
          this.neovis.edges.add(edge);
        } catch {}
      }
      this.undo_object = {
        nodes: this.neovis.nodes.get(),
        edges: this.neovis.edges.get(),
      };
      console.error('Conexión realizada con éxito');
    }

    // Set 'first' to false to indicate that the graph has been initialized
    this.first = false;

    // Apply no-physics layout: circular on first load, incremental on updates
    this.applyNoPhysicsLayout(isInitialLoad);

    // Create a sidebar with a list of nodes and emit an event with the nodes and edges of the graph
    this.createNodesListSidebar(this.neovis.nodes.get());
    this.nodesAndLinks.emit({
      nodes: this.neovis.nodes.get(),
      links: this.neovis.edges.get(),
    });

    // Log the nodes and edges for debugging
    console.log('Nodos:', this.neovis.nodes.get());
    console.log('Relaciones:', this.neovis.edges.get());
  }

  setInitialCypher(neovisConfig, neo4jQuerys, investigationType, search) {
    let query;
    switch (investigationType) {
      case 'cuenta':
        query = search
          ? neo4jQuerys.AT_37_search_match_account
          : neo4jQuerys.AT_37_default_search_match_account;
        break;
      case 'cedula':
        query = search
          ? neo4jQuerys.AT_37_match_transfers_and_accounts_by_CI
          : neo4jQuerys.AT_37_default_search_match_customer;
        break;
      case 'caso':
        query = search
          ? neo4jQuerys.AN_search_cases
          : neo4jQuerys.AN_default_search_cases;
        break;
      default:
        console.log('Invalid investigation type');
        return;
    }
    console.log('query', query);
    this.actualQuery = query;
    neovisConfig.setInitialCypher(query);
    return neovisConfig;
  }

  /**
   * Initializes neovis with default configuration and sets initial cypher query to match_account,
   * registers onCompleted event to call createNodesListSidebar function
   */
  startNeovis() {
    // Get singleton instance of NeoVisConfig and set default configuration
    let neovisConfig = NeoVisConfigSingleton.getInstance();
    const defaultConfig = Default_Config;
    neovisConfig.setNeo4jConfig(defaultConfig.neo4j as Neo4jConfig);
    neovisConfig.addNodeConfig(defaultConfig.visConfig.nodes);
    neovisConfig.addEdgeConfig(defaultConfig.visConfig.edges);
    neovisConfig.addLabels(defaultConfig.labels);
    neovisConfig.addRelationships(defaultConfig.relationships);

    // Set initial cypher query to match_account
    neovisConfig = this.setInitialCypher(
      neovisConfig,
      this.neo4jQuerys,
      this.element.investigationType,
      this.reference
    );

    // Get configuration and initialize neovis
    this.config = neovisConfig.getConfig();
    this.neovis = new NeoVis(this.config);
    this.neovis.renderOptions = { stabilize: true }; // Habilita actualizaciones incrementales

    // Register onCompleted event to call createNodesListSidebar function
    this.neovis.registerOnEvent('completed', this.onCompleted.bind(this));

    // Register error event to handle connection errors
    this.neovis.registerOnEvent('error', this.onError.bind(this));
  }

  /**
   * @param event - The right-click event
   * Prevents the default right-click behavior, sets the position of the context menu to the mouse position,
   * sets node_type to undefined, sets item to an empty object, and opens the context menu
   */
  onRightClick(event: MouseEvent) {
    // Prevent the default right-click behavior
    event.preventDefault();

    // Set the position of the context menu to the mouse position
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';

    // Set node_type to undefined
    this.node_type = undefined;

    // Set item to an empty object
    let item = {};
    this.matMenuTrigger.menuData = { item };

    // Open the context menu
    this.matMenuTrigger.openMenu();
  }

  /**
   * Opens import modal, creates file input elements for nodes and edges, adds event listeners to read and import files
   */
  async importExcel() {
    // Open import modal
    await this.openImportModal();

    // Create file input element for nodes
    const nodesInput = document.createElement('input');
    nodesInput.type = 'file';
    nodesInput.accept = '.csv';
    const nodesPromise = new Promise((resolve, reject) => {
      nodesInput.addEventListener('change', async (event) => {
        // Read and import nodes file
        const nodesFile = (event.target as HTMLInputElement).files[0];
        const nodesReader = new FileReader();
        nodesReader.onload = (event) => {
          resolve(ImportNodesFunction(event, this.neovis));
        };
        nodesReader.onerror = (event) => {
          reject(event);
        };
        nodesReader.readAsText(nodesFile);
      });
    });
    nodesInput.click();

    // Create file input element for edges
    const edgesInput = document.createElement('input');
    edgesInput.type = 'file';
    edgesInput.accept = '.csv';
    const edgesPromise = new Promise((resolve, reject) => {
      edgesInput.addEventListener('change', async (event) => {
        // Read and import edges file
        const edgesFile = (event.target as HTMLInputElement).files[0];
        const edgesReader = new FileReader();
        edgesReader.onload = (event) => {
          resolve(ImportEdgesFunction(event, this.neovis));
        };
        edgesReader.onerror = (event) => {
          reject(event);
        };
        edgesReader.readAsText(edgesFile);
      });
    });
    edgesInput.click();

    // Wait for both promises to complete before continuing
    try {
      await Promise.all([nodesPromise, edgesPromise]);
      console.log('Import completed successfully');
    } catch (error) {
      console.error('Import failed:', error);
    }

    this.nodesAndLinks.emit({
      nodes: this.neovis.nodes.get(),
      links: this.neovis.edges.get(),
    });
    this.createNodesListSidebar(this.neovis.nodes.get());
  }

  /**
   * Exports the current graph as a PNG image
   */
  exportGraph() {
    ExportGraph(this.neovis);
  }

  /**
   * Clears nodes and edges from the graph, and adds nodes and edges from the undo_object if it exists
   */
  rehacer() {
    // Clear nodes and edges from the graph
    this.neovis.nodes.clear();
    this.neovis.edges.clear();

    // Add nodes and edges from the undo_object if it exists
    if (this.undo_object) {
      for (let node of this.undo_object.nodes) {
        try {
          this.neovis.nodes.add(node);
        } catch (err) {
          console.log('Error adding', node);
        }
      }
      for (let edge of this.undo_object.edges) {
        this.neovis.edges.add(edge);
      }
    }
  }

  /**
   * Opens import modal with warning message
   */
  async openImportModal(): Promise<void> {
    const dialogRef = this.dialog.open(ModalImportComponent, {
      width: '500px',
      data: {
        title: 'Advertencia',
        message:
          'Para cargar los datos correctamente, sube primero el archivo nodes.csv y luego el archivo edges.csv',
      },
      panelClass: 'my-class-modal-import',
    });
    await dialogRef.afterClosed().toPromise();
  }

  goToCase() {
    console.log(this.node);
    this.router.navigate(['case/' + this.node.raw.properties._id]);
  }

  toggleDrawer() {
    this.out.emit('maximize');
  }

  open3DGraph() {
    this.dialog.open(ForceGraphComponent, {
      data: { nodes: this.neovis.nodes.get(), links: this.neovis.edges.get() },
      panelClass: 'custom-dialog-container',
    });
  }
}
